<template>
  <div class="outer-box max-w-xl">
    <h4>Enable Locked Features</h4>

    <b-alert show variant="danger" class="text-left m-3">
      Enables the SMS sending feature for sub-accounts that were only disabled through the Support
      portal's Lock SMS feature. This does not apply to SMS services blocked due to opt-out rates or
      error rates. <strong>FOR DEV TEAM ONLY</strong>
    </b-alert>

    <div class="inner-box" style="text-align: left; width: 500px">
      <select class="hl_input--wrap" type="text" v-model="feature">
        <!-- <option value="email">Email</option> -->
        <option value="sms">SMS</option>
      </select>
      <input
        class="mt-4 hl_input--wrap"
        type="text"
        placeholder="Location ID"
        v-model="locationId"
      />
      <button
        class="btn btn-primary mt-4"
        @click="UnlockFeatureForLocation"
        :disabled="!locationId || isLoading"
      >
        <moon-loader v-if="isLoading" :loading="true" size="21px" color="#fafafa" />
        <span v-else class="capitalize">Unlock {{ feature }}</span>
      </button>
      <pre v-if="response" style="background-color: #f2f7fa; padding: 16px; margin-top: 16px">{{
        response
      }}</pre>
    </div>
  </div>
</template>

<script>
import { EmailISVService } from "@/services";

export default {
  name: "enable-blocked-features",
  data() {
    return {
      locationId: "",
      feature: "sms",
      response: null,
      isLoading: false,
    };
  },
  methods: {
    async UnlockFeatureForLocation() {
      this.isLoading = true;
      try {
        this.response = await EmailISVService.unlockFeature(this.locationId, this.feature);
        this.isLoading = false;
      } catch (err) {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.capitalize {
  text-transform: capitalize;
}
</style>
